import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

declare var OneTrust: any;

@Component({
  selector: 'app-privacy-notice',
  templateUrl: './privacy-notice.component.html',
  styleUrls: ['./privacy-notice.component.scss']
})
export class PrivacyNoticeComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute) {
  }

  currentRoute = '';

  ngOnInit(): void {

    window.scrollTo(0, 0);

    this.activatedRoute.url.subscribe((urlSegments) => {
      this.currentRoute = urlSegments.join('/');
    });

    OneTrust.NoticeApi.Initialized.then(() => {
      OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/storage-container/20bbc57b-6134-4535-8062-a1745b771851/privacy-notices/d70a35fb-b078-448a-aa0b-ebd0015d6d4d/published/privacynotice.json"]);
    });
  }

  // create auto scroll

  @HostListener('window:click', ['$event'])
  onClick(e: MouseEvent) {
    const target = e.target as HTMLElement;

    if (target.tagName.toLowerCase() === 'a' && target.hasAttribute('href') && !target.hasAttribute('routerLink')) {
      const href = target.getAttribute('href');
      const elementId = href.substring(1);
      const targetElement = document.getElementById(elementId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        e.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/privacy-notice/privacy-notice.component.ts